import CountUpAnimation from "./UI/CountUpAnimation";


export default function TotalsSummaryCard({ items = [], duration = 1000, animate = true }) {

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: items.length <= 2
      ? `repeat(${items.length}, minmax(0, 1fr))`
      : undefined,
    gap: '0.5rem',
    textAlign: 'center',
  };

  // For 3+ items, use CSS class for responsive columns
  const gridClassName = items.length > 2
    ? `grid grid-cols-2 sm:grid-cols-${Math.min(items.length, 4)} gap-2 sm:gap-4 text-center`
    : '';

  return (
    <div className="p-3 sm:p-4 bg-white rounded-lg shadow-lg mb-4">
      <div className={gridClassName} style={items.length <= 2 ? gridStyle : undefined}>
        {items.map((item, idx) => (
          <div key={idx}>
            <div className="text-[10px] sm:text-xs text-gray-500 uppercase mb-1 break-words">{item.label}</div>
            <div className="text-xl font-semibold">
              <CountUpAnimation
                end={item.value}
                suffix={item.suffix || ''}
                duration={duration}
                animate={animate}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
